import * as React from "react";

import {useUserAttributes} from "@khan/shared-core";

import {preferReducedMotion} from "./internal/prefer-reduced-motion.ts";

/**
 * A hook that returns whether a user prefers reduced motion
 */
export const usePrefersReducedMotion = (): boolean => {
    const userAttributes = useUserAttributes();

    const [prefersReducedMotion, setPrefersReducedMotion] = React.useState(
        userAttributes?.prefersReducedMotion ?? true,
    );

    // If running on server, we cannot use matchMedia - so this has to run
    // only on the client
    React.useEffect(() => {
        const currentValue = preferReducedMotion(userAttributes);
        setPrefersReducedMotion(currentValue);
    }, [userAttributes]);
    return prefersReducedMotion;
};
